import React, {useState, useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import {useDispatch} from 'react-redux';
//MUI
import Grid from '@mui/material/Grid';
//DS
import {logIn} from 'src/redux-app';
import {RedirectCallback} from 'lib.front';
import {transformacion} from 'lib.common';
import {urls} from 'src/config';
import * as keys from 'src/config/keys';

const pasos = [
   'Verificando sesión',
   'Recuperando información de usuario de Data Service',
   'Estableciendo información de sesión',
   'Recuperando perfil de aplicación',
   'Recuperando escritorio de usuario'
];
const errorCredenciales =
   'Sus credenciales no son validas para esta aplicación, inicie sesión con una cuenta autorizada o comuniquese con Data Service para mayor información.';
function Callback() {
   const history = useHistory();
   //REDUX
   const dispatch = useDispatch();
   //Control de los mensajes de carga
   const [pasoActual, setpasoActual] = useState(-1);
   //Control de los mensajes de informacion
   const [info, setinfo] = useState('');
   const [infoProps, setinfoProps] = useState({});
   function resetInfo() {
      setinfo('');
      setinfoProps({});
   }
   function setError(errMsg) {
      setinfo(errMsg.toString());
      setinfoProps({color: 'error'});
      setpasoActual(-1);
   }
   //Parametros
   const [queryParams, setqueryParams] = useState(null);
   //Informacion de usuario general
   const [usuarioGeneral, setusuarioGeneral] = useState(null);
   useEffect(() => {
      if (usuarioGeneral && usuarioGeneral.token) {
         setpasoActual(2);
         //Recuperar informacion general
         const myHeader = new Headers();
         //myHeaders.append('Content-Type', 'application/json');
         myHeader.append('Authorization', `Bearer ${usuarioGeneral.token}`);
         fetch(urls.logIn, {method: 'POST', headers: myHeader, credentials: 'include'})
            .then(res => {
               if (res.ok) {
                  return res.json();
               }
               if (res.status === 403) {
                  //Error de credenciales
                  setError(errorCredenciales);
                  return null;
               }
               return res.text().then(text => {
                  throw new Error(text);
               });
            })
            .then(res => {
               if (res && res.token) {
                  recuperarUsuarioAplicacion(new URL(urls.backEnd).toString());
               } else {
                  setError(errorCredenciales);
               }
            })
            .catch(setError);
      }
   }, [usuarioGeneral]);
   //ya tiene la cookie con el token
   function recuperarUsuarioAplicacion(uriUserInfo) {
      setpasoActual(3);
      /**
       * Recuperar informacion de usuario de aplicacion
       */
      reduxSetSesion(usuarioGeneral);
   }
   //====Recuperacion de escritorio

   //RECUPERAR ESCRITORIO
   function redirectOriginalView() {
      setpasoActual(5);
      if (queryParams && queryParams.origin_uri) {
         history.push(queryParams.origin_uri);
      } else {
         history.push('/');
      }
   }
   function reduxSetSesion(userInfo) {
      setpasoActual(4);
      const {token, appInfo, ...usuarioParcial} = userInfo;
      const usuarioFinal = {
         codigo: usuarioParcial.sub,
         nombre: usuarioParcial.name,
         apPaterno: usuarioParcial.family_name,
         apMaterno: usuarioParcial.apMaterno,
         usuario: usuarioParcial.nickname,
         email: usuarioParcial.email,
         condicion: usuarioParcial.condicion,
         sucursal: usuarioParcial.sucursal,
         avatar: usuarioParcial.picture,
         especialidad: usuarioParcial.especialidad,
         fechaVigencia: usuarioParcial.fechaExpiracion,
         sistema: keys.appScope,
         key: usuarioParcial.key
      };
      dispatch(logIn(usuarioFinal, token, appInfo));
      //Recuperar info de usuario
      redirectOriginalView();
   }
   //Primera carga de verificacion
   useEffect(() => {
      setpasoActual(0);
      const query = transformacion.getHashQueryString(window.location.search);
      setqueryParams(query);
      if (query.token) {
         //si tiene token id
         const uriUsuarioData = transformacion.appendUrl(keys.dsApiAuth, 'userinfo').toString();
         recuperarUsuarioGeneral(uriUsuarioData, query.token, query.scope);
      } else {
         verificarSesion(query);
      }
   }, []);
   function recuperarUsuarioGeneral(uriUserInfo, token) {
      setpasoActual(1);
      //Recuperar informacion general
      const myHeader = new Headers();
      //myHeaders.append('Content-Type', 'application/json');
      myHeader.append('Authorization', `Bearer ${token}`);
      fetch(uriUserInfo, {headers: myHeader})
         .then(res => {
            if (res.ok) {
               return res.json();
            }

            if (res.status === 403) {
               //Error de credenciales
               throw new Error(errorCredenciales);
            }
            return res.text().then(text => {
               throw new Error(text);
            });
         })
         .then(res => {
            const accesoAppActual = res.appInfo && Boolean(res.appInfo[keys.appId]);
            if (accesoAppActual) {
               setusuarioGeneral({...res, token});
            } else {
               throw new Error(errorCredenciales);
            }
            //recuperar informacion de usuario
         })
         .catch(setError);
   }

   function verificarSesion(queryParams) {
      fetch(urls.verify, {credentials: 'include'})
         .then(res => {
            if (res.ok) {
               return res.json();
            }
            if (res.status === 403) {
               //'redireccionar a log-in'
               history.push({
                  pathname: '/log-in',
                  search: `?origin_uri=${queryParams.origin_uri || '/'}`
               });
            }
            return res.text().then(text => {
               throw new Error(text);
            });
         })
         .then(res => {
            const uriUsuarioData = transformacion.appendUrl(keys.dsApiAuth, 'userinfo').toString();
            recuperarUsuarioGeneral(uriUsuarioData, res.token);
         })
         .catch(setError);
   }

   return (
      <Grid container justifyContent="center" style={{height: '100%'}}>
         <RedirectCallback
            appName={keys.appName}
            //logoApp=""
            pasos={pasos}
            pasoActual={pasoActual}
            infoMsg={info}
            infoMsgProps={infoProps}
         />
      </Grid>
   );
}
export default Callback;
